import { setStatus } from 'shared/common/slices/formSlice';
import { EStatus } from 'shared/common/types/form';
import { TThunk } from 'shared/common/types/thunk';

export const setCallbackInit = (): TThunk => dispatch => {
  dispatch(setStatus(EStatus.Initial));
};
